// extracted by mini-css-extract-plugin
export var divider = "_xj-0";